export const errorMessage = (
  cause: unknown,
  fallback = "Something went wrong"
) => (cause instanceof Error ? cause.message : fallback)
